import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BasicInput from '../../components/BasicInput';
import ButtonTextIcon, { BtnType } from '../../components/BtnIcon';
import { ModalActionType, ModalProps } from '../../components/Modal';
import TextAreaInput from '../../components/TextAreaInput';
import api from '../../config/axios';
import { maskCPF } from '../../helpers/inputMasks.js';
import { validateCpf } from '../../helpers/validate';
import DefaultLayout from '../../Layout';

type FreelancerSellerProps = {
    name: string,
    cpf: string,
    paymentDetails: string,
    isActive: boolean
}

export default function NewFreelancer() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [showToastSuccess, setShowToastSuccess] = useState(false);
  const [showToastError, setShowToastError] = useState(false);
  const [modal, setModal] = useState<ModalProps | null>(null);
  const [token] = useState({ headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } });
  const [freelancer, setFreelancer] = useState<FreelancerSellerProps>({
    name: '',
    cpf: '',
    paymentDetails: '',
    isActive: true,
  });

  function validateFreelancerFields(): boolean {
    if (freelancer.name.length >= 3 && validateCpf(freelancer.cpf)) {
      return true;
    }
    return false;
  }

  async function saveFreelancer() {
    try {
      setLoading(true);
      await api.post('/admin/freelancer', freelancer, token);
      setLoading(false);
      navigate(-1);
    } catch (err: any) {
      console.log(err.response.data);
      setModal({ title: 'Não foi possível.', children: 'Não foi possível cadastrar. Verifique se o CPF já não está cadastrado em nome de outro vendedor freelancer.', actions: [{ label: 'Ok, entendi', onClick: () => setModal(null), type: ModalActionType.PRIMARY }] });
    }
  }

  return (

    <DefaultLayout
      pageTitle="Representante"
      loading={loading}
      showToastSuccess={showToastSuccess}
      showToastError={showToastError}
      showRightSlider={false}
      rightSliderContent={null}
      modal={modal}
      setCloseRightSlider={() => null}
    >
      <div className="row products">
        <div className="col-12 p-0 card-bg p-4">
          <h1>Representante</h1>
          <div className="row">
            <div className="col-4">
              <BasicInput
                id="representante-nome"
                label="Nome"
                readOnly={false}
                helper="Ex. José Antunes"
                error={freelancer.name.length < 3 ? 'Digite um nome válido' : ''}
                value={freelancer.name}
                type="text"
                onChange={(data) => setFreelancer({ ...freelancer, name: data })}
              />
            </div>
            <div className="col-4">
              <BasicInput
                id="representante-cpf"
                label="CPF"
                readOnly={false}
                helper="Ex. 092.283.000-20"
                error={!validateCpf(freelancer.cpf) ? 'Digite um CPF válido' : ''}
                value={freelancer.cpf}
                type="text"
                onChange={(data) => setFreelancer({ ...freelancer, cpf: maskCPF(data) })}
              />
            </div>
            <div className="col-12">
              <TextAreaInput
                id="representantes-obs"
                label="Observações"
                readOnly={false}
                helper="Ex. lembretes sobre dados de pagamento."
                error=""
                value={freelancer.paymentDetails}
                onChange={(data) => setFreelancer({ ...freelancer, paymentDetails: data })}
              />
            </div>
            <div className="col-12 footer">
              <ButtonTextIcon
                label="Salvar"
                type={BtnType.PRIMARY}
                icon="backup"
                active={validateFreelancerFields()}
                onClick={() => saveFreelancer()}
                ref={null}
              />
            </div>
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
}
